export default "__VITE_ASSET__DrT7DgcJ__"